package com.essntl.features.country.data.repository

import com.essntl.core.supabase.*
import com.essntl.core.utils.repository.Repository
import com.essntl.features.country.data.supabase.CountrySupabaseDataSource
import com.essntl.features.country.data.supabase.toRequestMap
import com.essntl.features.country.domain.model.CountryModel
import com.essntl.features.country.domain.repository.CountryRepository
import org.koin.core.annotation.Single

@Single(binds = [CountryRepository::class])
class CountryRepositoryImpl internal constructor(
    private val supabase: CountrySupabaseDataSource,
) : Repository(), CountryRepository {

    override suspend fun get(countryId: String): Result<CountryModel> =
        runCatching {
            supabase
                .getById(countryId)
                .toModel()
        }

    override suspend fun getCountCountriesByName(name: String): Result<Long> =
        runCatching {
            supabase.getCount {
                filter {
                    ilike("name", name)
                }
            }
        }

    override suspend fun getAll(): Result<List<CountryModel>> =
        runCatching {
            supabase
                .getAll()
                .map {
                    it.toModel()
                }
        }

    override suspend fun insert(country: CountryModel): Result<CountryModel> =
        runCatching {
            supabase
                .insert(country.toRequestMap())
                .toModel()
        }

    override suspend fun update(country: CountryModel): Result<CountryModel> =
        runCatching {
            supabase
                .update(id = country.id, country.toRequestMap())
                .toModel()
        }

    override suspend fun delete(country: CountryModel): Result<Unit> =
        runCatching {
            supabase.delete(id = country.id)
        }
}
